<template>
    <div class="launch-entry-page">
        <LaunchVersionBanner current="new" />
        <div class="launch-entry-page__header">发起签署</div>

        <div class="launch-entry-page__cards">
            <div class="entry-card entry-card--ai" @click="goAiDraft">
                <div class="entry-card__title entry-card__title--with-icon">
                    <span class="entry-card__icon">
                        <img :src="iconAiDraft" alt="AI智能起草" />
                    </span>
                    <span class="entry-card__title__text">
                    AI智能起草 </span>
                    <img :src="iconHot" class="entry-card__hot" alt="热门" />
                </div>
                <div class="entry-card__desc">
                    法务/业务员高频使用<br />
                    （消耗积分）
                </div>
                <Button type="primary" long class="entry-card__btn" >
                    立即生成
                </Button>
            </div>

            <div v-if="canTemplateLaunch" class="entry-card entry-card--tpl" @click="goTemplate">
                <div class="entry-card__head">
                    <div class="entry-card__icon">
                        <img :src="iconTemplateLaunch" alt="从模板发起" />
                    </div>
                    <span class="entry-card__title__text">
                    <div class="entry-card__title">从模板发起</div>
                    </span>
                </div>
                <div class="entry-card__desc">
                    标准合同重复使用场景<br />
                    快速发起
                </div>
                <Button type="primary" long class="entry-card__btn" >
                    选择模板
                </Button>
            </div>

            <div class="entry-card entry-card--file" @click="goUploadFile">
                <div class="entry-card__head">
                    <div class="entry-card__icon">
                        <img :src="iconUploadFile" alt="上传文件" />
                    </div>
                    <span class="entry-card__title__text">
                        <div class="entry-card__title">上传文件</div>
                    </span>
                </div>
                <div class="entry-card__desc">
                    支持Word/PDF<br />
                    小于20MB，自动识别文本
                </div>
                <Button type="primary" long class="entry-card__btn" >
                    立即上传
                </Button>
            </div>
        </div>

        <div
            v-if="canBatchSign"
            class="batch-entry"
            @click="goBatch"
        >
            <div class="batch-entry__icon">
                <img :src="iconBatchSign" alt="批量签署" />
            </div>
            <div class="batch-entry__content">
                <div class="batch-entry__title">批量签署</div>
                <div class="batch-entry__desc">一次上传，同时发给多人签署</div>
            </div>
        </div>
    </div>
</template>

<script>
import LaunchVersionBanner from '@/components/LaunchVersionBanner/index.vue'
import { getLaunchEdition, LAUNCH_EDITION } from '@/utils/launchVersion'

const FILE_LAUNCH_DRAFT_KEY = 'sign_file_launch_draft_v1'
const BATCH_LAUNCH_DRAFT_KEY = 'sign_batch_launch_draft_v1'

export default {
    name: 'signLaunchEntry',
    components: {
        LaunchVersionBanner
    },
    created() {
        if (getLaunchEdition() === LAUNCH_EDITION.OLD) {
            this.$router.replace({ path: '/sign/index', query: this.$route.query })
            return
        }
        this.clearLaunchDrafts()
    },
    data() {
        return {
            iconAiDraft: require('@/assets/images/newsign/Aizhinengqicao.png'),
            iconTemplateLaunch: require('@/assets/images/newsign/congmobanfaqi.png'),
            iconUploadFile: require('@/assets/images/newsign/shangchuanwenjian.png'),
            iconBatchSign: require('@/assets/images/newsign/piliangqianshu.png'),
            iconHot: require('@/assets/images/newsign/huomiao.png')
        }
    },
    computed: {
        canBatchSign() {
            const hasAuth = (this.$store.state.auth || []).indexOf('approval-sign') !== -1
            const identity = this.$store.state.identity
            return hasAuth && (identity === 1 || identity === 3)
        },
        canTemplateLaunch() {
            // const auth = this.$store.state.auth || []
            // const userInfo = this.$store.state.userInfo || {}
            // const companyInfoStr = localStorage.getItem(document.domain + '_companyInfo')
            // let companyInfo = {}
            // try {
            //     companyInfo = companyInfoStr ? JSON.parse(companyInfoStr) : {}
            // } catch (e) {
            //     companyInfo = {}
            // }
            // const hasTemplateAuth = auth.indexOf('template') !== -1 || auth.indexOf('template-components') !== -1 || auth.indexOf('approval-sign') !== -1
            // const switchVal = userInfo.is_template !== undefined ? Number(userInfo.is_template) : (companyInfo.is_template !== undefined ? Number(companyInfo.is_template) : null)
            // if (switchVal === 0) return false
            // if (switchVal === 1) return true
            let hasTemplateAuth = true
            return hasTemplateAuth
        }
    },
    methods: {
        clearLaunchDrafts() {
            this.$store.commit('CLEAR_SIGN_FILE_LAUNCH_DRAFT')
            try {
                localStorage.removeItem(FILE_LAUNCH_DRAFT_KEY)
                localStorage.removeItem(BATCH_LAUNCH_DRAFT_KEY)
            } catch (e) {
                // ignore
            }
        },
        goAiDraft() {
            this.$router.push({ path: '/sign/file', query: { entry: 'ai', ai: '1' } })
        },
        goTemplate() {
            this.$router.push({ path: '/sign/file', query: { entry: 'template' } })
        },
        goUploadFile() {
            this.$router.push({ path: '/sign/file', query: { entry: 'file' } })
        },
        goBatch() {
            this.$router.push({ path: '/sign/batch-launch' })
        }
    }
}
</script>

<style scoped lang="scss">
.launch-entry-page {
    background: #edf0f9;
    min-height: calc(100vh - 164px);
    padding: 0;
}

.launch-entry-page__header {
    height: 58px;
    background: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-size: 20px;
    font-weight: 600;
    color: #2f3a4f;
    margin-bottom: 12px;
    border: 1px solid #e9edf6;
}

.launch-entry-page__cards {
    border-radius: 10px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;
}

.entry-card {
    background: #fff;
    border-radius: 10px;
    padding: 22px 20px 18px;
    box-shadow: 0 4px 14px rgba(40, 57, 90, 0.05);
    border: 1px solid #edf1f8;
    min-height: 250px;
    min-width: 300px;
    // min-width: 540px;
    // min-height: 380px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    align-items: center;
    text-align: center;
    // transition: all 0.2s ease;
}

.entry-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 22px rgba(30, 54, 97, 0.08);
    border-color: #4877e8;
}

.entry-card__head {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-bottom: 4px;
}

.entry-card__icon {
    width: 26px;
    height: 26px;
    border-radius: 0;
    display: flex;
    align-items: center;
    justify-content: center; 
    overflow: hidden;
    margin: 0;
}

.entry-card__icon img {
    width: 100%;
    height: 100%;
    display: block;
}

.entry-card--ai .entry-card__icon {
    background: #edf4ff;
}

.entry-card--tpl .entry-card__icon {
    background: #eef7ff;
}

.entry-card--file .entry-card__icon {
    background: #edf8ff;
}
.entry-card__title__text {
    margin: 5px 16px;
}
.entry-card__title {
    font-size: 20px;
    font-weight: 600;
    color: #2f3a4f;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    line-height: 1.3;
    margin: 0;
    text-align: center;
}

.entry-card__title--with-icon {
    gap: 6px;
    margin-top: 2px;
}

.entry-card__hot {
    width: 26px;
    height: 26px;
    object-fit: contain;
    display: inline-block;
}

.entry-card__desc {
    margin-top: 14px;
    font-size: 16px;
    color: #1B2742;
    line-height: 1.6;
    flex: 1;
    margin-bottom: 0;
}

.entry-card__btn {
    margin-top: 10px;
    height: 36px;
    border-radius: 10px;
    font-size: 14px;
}

/deep/ .entry-card__btn.ivu-btn-primary {
    background: #4d79e8;
    border-color: #4d79e8;
    box-shadow: 0 6px 14px rgba(77, 121, 232, 0.26);
}

/deep/ .entry-card__btn.ivu-btn-primary:hover {
    background: #3f6ddd;
    border-color: #3f6ddd;
}

.batch-entry {
    margin-top: 14px;
    background: #FFFFFF;
    border-radius: 10px;
    border: 1px solid #e7ecf7;
    height: 140px;
    
    padding: 0 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    cursor: pointer;
    transition: all 0.2s;
}

.batch-entry:hover {
    border-color: #4877e8;
    box-shadow: 0 10px 22px rgba(27, 39, 66, 0.08);
}

.batch-entry__icon {
    width: 74px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.batch-entry__icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
}

.batch-entry__title {
    font-size: 20px;
    font-weight: 600;
    color: #2f3a4f;
    line-height: 1.2;

    margin: 5px 10px;
    margin-left: 0;
}

.batch-entry__desc {
    margin-top: 0;
    font-size: 16px;
    color: #1B2742;
    white-space: nowrap;
}

@media (max-width: 1200px) {
    .launch-entry-page__cards {
        grid-template-columns: 1fr;
    }
}
</style>
